var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"info-tooltip",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"info-tooltip__button",attrs:{"icon":"","rounded":"","x-small":""}},on),[_vm._v("i")])]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }